import { Link } from 'react-router-dom';

const footerNavColumns = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '分类浏览', href: '/category/all' },
      { label: '热门排行', href: '/#rankings' },
      { label: '最新更新', href: '/#latest' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系方式', href: '/about#contact' },
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/about' },
      { label: '阅读指南', href: '/about' },
      { label: '意见反馈', href: '/about#contact' },
      { label: '商务合作', href: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="bg-background-50 rounded-2xl px-8 py-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
              <div>
                <Link to="/" className="inline-block mb-4">
                  <span className="font-heading text-2xl font-bold text-primary-600">
                    韩漫漫画
                  </span>
                </Link>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  韩漫漫画网站提供免费韩漫在线下拉式阅读体验，无删减韩漫完整呈现，画质清晰流畅。每日更新热门韩漫，满足各类韩漫爱好者的阅读需求。
                </p>
                <div className="flex items-center gap-4 mt-5">
                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                    aria-label="微博"
                    rel="nofollow"
                  >
                    <i className="ri-weibo-line text-base"></i>
                  </a>
                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                    aria-label="微信"
                    rel="nofollow"
                  >
                    <i className="ri-wechat-line text-base"></i>
                  </a>
                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                    aria-label="B站"
                    rel="nofollow"
                  >
                    <i className="ri-bilibili-line text-base"></i>
                  </a>
                </div>
              </div>

              {footerNavColumns.map((column) => (
                <div key={column.title}>
                  <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                    {column.title}
                  </h4>
                  <ul className="flex flex-col gap-3">
                    {column.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.href}
                          className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 韩漫漫画 版权所有 | 本站内容仅供学习交流
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <Link to="/about" className="hover:text-primary-600 transition-colors whitespace-nowrap">用户协议</Link>
              <span className="text-foreground-300">|</span>
              <Link to="/about" className="hover:text-primary-600 transition-colors whitespace-nowrap">隐私政策</Link>
              <span className="text-foreground-300">|</span>
              <Link to="/about#contact" className="hover:text-primary-600 transition-colors whitespace-nowrap">联系我们</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}